import Invoice from '../../common/models/Invoice.ts';
import Driver from '../types/Driver.ts';
import PdfPageWithText from '../types/PdfPageWithText.ts';
import PdfProcessedPage from '../types/PdfProcessedPage.ts';
import PdfTextTest, { StringAtIndexTest } from '../types/PdfTextTest.ts';
import { compute_pdf_tests, compute_pdf_line_items } from '../pdf_parser.ts';
import { stamp } from '../pdf_writer.ts';
import PdfLineItem from '../types/PdfLineItem.ts';

interface PartNameDescriptionCursor {
    "part_name": string,
    "description": string,
    "current_index_cursor": number
}

export default class extends Driver {
    constructor() {
        super()
    }

    parse_project_NaN(pdf_text_contents: string[]): string {
        const tests = [
            {
                "string": "PO #",
                "elements_to_skip": 2
            } as StringAtIndexTest
        ]

        let pdf_tests = {
            "first_string": 'PO Date',
            "tests": tests,
            "elements_to_skip_to_return": 12
        } as PdfTextTest

        return compute_pdf_tests(pdf_text_contents, pdf_tests) ?? ""
    }
    
    parse_invoice_NaN(pdf_text_contents: string[]): string {
        if (pdf_text_contents[0].startsWith('Print Date:')
            && pdf_text_contents[4].startsWith('Page ')
        ) {
            return pdf_text_contents[2]
        } else {
            return ""
        }
    }
    
    parse_total(pdf_text_contents: string[]): number | null {
        const tests = [
            {
                "string": "Taxes",
                "elements_to_skip": 4
            } as StringAtIndexTest,
            {
                "string": "Total",
                "elements_to_skip": 8
            } as StringAtIndexTest
        ]
    
        let pdf_tests = {
            "first_string": 'Subtotal',
            "tests": tests,
            "elements_to_skip_to_return": 10
        } as PdfTextTest

        const total = compute_pdf_tests(pdf_text_contents, pdf_tests)
    
        return this.parse_money_string(total)
    }

    parse_invoice_line_items(pdf_text_contents: string[]): PdfLineItem[] | null {
        let tests = [
            {
                "string": "Multiplier",
                "elements_to_skip": 1,
            }  as StringAtIndexTest,
            {
                "string": "Amount(Net)",
                "elements_to_skip": 3,
            }  as StringAtIndexTest
        ]

        let pdf_tests = {
            "first_string": 'Discount',
            "tests": tests,
            "elements_to_skip_to_return": 5
        } as PdfTextTest

        const check_valid_next_line = function (arg_text_contents: string[], arg_check_from_index: number) {
            let current_index_cursor = arg_check_from_index 
            if (current_index_cursor > arg_text_contents.length) {
                return false 
            }
            
            const postive_integer_regex = /^\d+$/;


            if (arg_text_contents[current_index_cursor - 1] === ""
                && postive_integer_regex.test(arg_text_contents[current_index_cursor])
                && arg_text_contents[current_index_cursor + 1] === " "
            ) {
                return true
            }
        }

        

        const get_part_description_and_index_cursor = function (arg_text_contents: string[], arg_check_from_index: number): PartNameDescriptionCursor {
            let loc_current_index_cursor = arg_check_from_index 
            let done = false

            if (loc_current_index_cursor > arg_text_contents.length) {
                done = true
            }
            
            const part_name = arg_text_contents[loc_current_index_cursor]
            let description = ""

            const postive_integer_regex = /^\d+$/;
            const two_place_decimal_regex = /^(?:\d{1,3}(?:,\d{3})*|\d+)\.\d{2}$/;
            

            loc_current_index_cursor += 2

            while (!done) {
                console.log("part_name", part_name)
                console.log("postive_integer_regex.test(arg_text_contents[loc_current_index_cursor]", postive_integer_regex.test(arg_text_contents[loc_current_index_cursor]), arg_text_contents[loc_current_index_cursor])
                console.log("two_place_decimal_regex.test(arg_text_contents[loc_current_index_cursor + 2]", two_place_decimal_regex.test(arg_text_contents[loc_current_index_cursor + 2]), arg_text_contents[loc_current_index_cursor + 2])
                console.log("two_place_decimal_regex.test(arg_text_contents[loc_current_index_cursor + 4]", two_place_decimal_regex.test(arg_text_contents[loc_current_index_cursor + 4]), arg_text_contents[loc_current_index_cursor + 4])
                console.log("two_place_decimal_regex.test(arg_text_contents[loc_current_index_cursor + 6]", two_place_decimal_regex.test(arg_text_contents[loc_current_index_cursor + 6]), arg_text_contents[loc_current_index_cursor + 6])

                if (postive_integer_regex.test(arg_text_contents[loc_current_index_cursor])
                    && two_place_decimal_regex.test(arg_text_contents[loc_current_index_cursor + 2])
                    && two_place_decimal_regex.test(arg_text_contents[loc_current_index_cursor + 4])
                    && two_place_decimal_regex.test(arg_text_contents[loc_current_index_cursor + 6])
                ) {
                    done = true

                } else {
                    description += arg_text_contents[loc_current_index_cursor] + " "
                    loc_current_index_cursor += 2
                }

                if (loc_current_index_cursor > arg_text_contents.length) {
                    done = true
                }
            }

            return {
                "part_name": part_name,
                "description": description,
                "current_index_cursor": loc_current_index_cursor
            } as PartNameDescriptionCursor

        }

        const func_parse_money_string = this.parse_money_string

        const parse_money_field = function (arg_text_contents: string[], arg_money_field_index: number) {
            let loc_money_field = arg_text_contents[arg_money_field_index]
            let loc_next_index = arg_money_field_index + 2
            if (arg_text_contents[arg_money_field_index + 1] !== " "
                && arg_text_contents[arg_money_field_index + 1] !== ""
            ) {
                loc_money_field += "" + arg_text_contents[arg_money_field_index + 1]
                loc_next_index++
            }

            return {
                "money_field": func_parse_money_string(loc_money_field),
                "next_index": loc_next_index
            }
        } 

        

        const line_item_parser = function (text_contents: string[], starting_index: number) {
            let line_items = []
            let current_index_cursor = starting_index 

            do {
                let line_number = text_contents[current_index_cursor]
                
                current_index_cursor += 2

                let part_name: string
                let description: string

                ({part_name, description, current_index_cursor} = get_part_description_and_index_cursor(text_contents, current_index_cursor))
                
                

                
                let new_line_item = {
                    line_number: line_number,
                    part_name: part_name,
                    part_description: description,
                    quantity: parseFloat(text_contents[current_index_cursor + 2]),
                    quantity_back_ordered: parseFloat(text_contents[current_index_cursor + 4]),
                    quantity_shipped: parseFloat(text_contents[current_index_cursor + 6]),
                    unit_of_measure: text_contents[current_index_cursor + 8],
                    price_per_unit: 0,
                    line_item_total: 0
                } as PdfLineItem

                console.log("current_index_cursor start", current_index_cursor);
                
                let price_per_unit: number | null 
                ({"money_field": price_per_unit, "next_index": current_index_cursor} = parse_money_field(text_contents, current_index_cursor + 10))

                let line_item_total: number | null

                console.log("text_contentscurrent_index_cursor + 4", text_contents[current_index_cursor + 4]);

                

                
                ({"money_field": line_item_total, "next_index": current_index_cursor} = parse_money_field(text_contents, current_index_cursor + 4))


                console.log("current_index_cursor end", current_index_cursor);
                new_line_item.price_per_unit = price_per_unit ?? 0
                new_line_item.line_item_total = line_item_total ?? 0
                // current_index_cursor += 18

                line_items.push(new_line_item)
                
            } while (check_valid_next_line(text_contents, current_index_cursor))

            return line_items
        }
        

        let line_iems = compute_pdf_line_items(pdf_text_contents, pdf_tests, line_item_parser) ?? null

        if (line_iems === null) {
            tests = [
                {
                    "string": "Taxes",
                    "elements_to_skip": 4,
                }  as StringAtIndexTest,
                {
                    "string": "Total",
                    "elements_to_skip": 8,
                }  as StringAtIndexTest
            ]

            pdf_tests = {
                "first_string": 'Subtotal',
                "tests": tests,
                "elements_to_skip_to_return": 14
            } as PdfTextTest

            line_iems = compute_pdf_line_items(pdf_text_contents, pdf_tests, line_item_parser) ?? null
        }
        
        return line_iems
    }

    check(pdf_text_contents: string[]): boolean {
        const tests = [
            {
                "string": "737 Charlotte St",
                "elements_to_skip": 2
            } as StringAtIndexTest,
            {
                "string": "Davenport, IA 52803",
                "elements_to_skip": 3
            } as StringAtIndexTest,
            {
                "string": "563-322-6204",
                "elements_to_skip": 4
            } as StringAtIndexTest
        ]
        
        let pdf_tests = {
            "first_string": 'Republic Electric Company, LLC',
            "tests": tests,
            "elements_to_skip_to_return": 5
        } as PdfTextTest

        return compute_pdf_tests(pdf_text_contents, pdf_tests) === "www.republicco.com"
    }

    parse_pages(pages: PdfPageWithText[]): PdfProcessedPage[] {
        return pages.map((page: PdfPageWithText) => {

            const pdfProcessedPage = new PdfProcessedPage({
                page_number: page.page_number,
                vendor: 'Republic Electric',
                project_NaN: this.parse_project_NaN(page.text_contents),
                invoice_NaN: this.parse_invoice_NaN(page.text_contents),
                line_items: this.parse_invoice_line_items(page.text_contents),
                total: this.parse_total(page.text_contents)
            })

            console.log("pdfProcessedPage", pdfProcessedPage)
            return pdfProcessedPage
        })
    }

    async stamp_invoices(invoices: Invoice[]): Promise<Invoice[]> {
        const x_coordinate = 5
        const y_coordinate = 845

        for (const index in invoices) {
            const invoice = invoices[index]
            if (invoice.pdf_bytes === null) {
                continue
            }

            const stamped_pdf_bytes = await stamp(x_coordinate, y_coordinate, invoice.invoice_information, invoice.pdf_bytes)
            invoices[index].stamped_pdf_bytes = stamped_pdf_bytes
            invoices[index].stamp_x = x_coordinate
            invoices[index].stamp_y = y_coordinate
        }

        return invoices  
    }
}

